import { fal } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AutoComplete, Input, Tag } from "antd";
import { uniq } from "lodash";
import { useTranslation } from "react-i18next";


export const FishboneFiltersTab = ({ iconFilter, setIconFilter, searchTerm, setSearchTerm, timeStartFilter, setTimeStartFilter, timeEndFilter, setTimeEndFilter, completionFilter, setCompletionFilter, responsibleFilter = "", setResponsibleFilter = (_: string) => {}, fishboneBranchs = [], tags = [], tagFilter = [], setTagFilter = (_: string[]) => {} }: any) => {

    const { t } = useTranslation();

    const commonTimes = [
        {
            name: t("pages.fishbone.filters.startOn.undefined"),
            value: "undefined",
        },
        {
            name: t("pages.fishbone.filters.startOn.past"),
            value: "past"
        },
        {
            name: t("pages.fishbone.filters.endOn.overdue"),
            value: "overdue"
        }
    ]

    const completions = [
        {
            name: t("pages.fishbone.filters.completion.not_started"),
            value: "not_started"
        },
        {
            name: t("pages.fishbone.filters.completion.in_progress"),
            value: "in_progress"
        },
        {
            name: t("pages.fishbone.filters.completion.completed"),
            value: "completed"
        }
    ]

    const startOnTimes = [
        {
            name: t("pages.fishbone.filters.startOn.ending_week"),
            value: "week"
        },
        {
            name: t("pages.fishbone.filters.startOn.ending_month"),
            value: "month"
        },
        {
            name: t("pages.fishbone.filters.startOn.ending_quarter"),
            value: "quarter"
        },
        {
            name: t("pages.fishbone.filters.startOn.ending_year"),
            value: "year"
        }
    ]

    const endOnTimes = [
        {
            name: t("pages.fishbone.filters.endOn.ending_week"),
            value: "week"
        },
        {
            name: t("pages.fishbone.filters.endOn.ending_month"),
            value: "month"
        },
        {
            name: t("pages.fishbone.filters.endOn.ending_quarter"),
            value: "quarter"
        },
        {
            name: t("pages.fishbone.filters.endOn.ending_year"),
            value: "year"
        }
    ]

    const allIcons: any = uniq([
        ...fishboneBranchs.map((i: any) => (i.icon ? i.icon : 'faCrosshairs')),
        ...fishboneBranchs.flatMap((b: any) => (b.items || []).map((i: any) => i.icon)).filter(Boolean),
    ]).sort();

    const allResponsibles: string[] = uniq(
        fishboneBranchs
            .flatMap((b: any) => (b.items || []))
            .map((i: any) => (i?.responsible || '').trim())
            .filter((r: string) => r.length > 0)
    ).sort((a: string, b: string) => a.localeCompare(b, undefined, { sensitivity: 'base' }));

    const responsibleOptions = allResponsibles.map((r) => ({ value: r }));

    return <>
        <Input
            onChange={(e) => {
                setSearchTerm(e.target.value);
            }}
            value={searchTerm}
            style={{
                marginLeft: 'auto',
                marginRight: '1em'
            }}
            placeholder="Search"
            className="SearchInput mt-05"
        ></Input>

        <strong className="text-left mt-2" style={{ marginBottom: '0.5rem' }}>
            {t('pages.navigator.all_tags')}
        </strong>
        <div className="text-left" style={{ marginBottom: '0.5rem' }}>
            {tags.length === 0 ? (
                <div style={{ color: 'var(--ant-color-text-tertiary)', fontSize: '0.85rem' }}>
                    {t('pages.navigator.no_tag')}
                </div>
            ) : (
                tags.map((tag: any) => (
                    <Tag.CheckableTag
                        key={tag.id}
                        checked={tagFilter.includes(tag.id)}
                        onClick={() => {
                            const next = tagFilter.includes(tag.id)
                                ? tagFilter.filter((id: string) => id !== tag.id)
                                : [...tagFilter, tag.id];
                            setTagFilter(next);
                        }}
                        className="tag"
                    >
                        {tag.name}
                    </Tag.CheckableTag>
                ))
            )}
        </div>

        <strong
            className="text-left mt-2"
            style={{ marginBottom: '0.5rem' }}
        >
            {t('pages.fishbone.all_icons')}
        </strong>

        {(allIcons || []).length == 0 ? (
            <div
                style={{
                    color: 'var(--ant-color-text-tertiary)'
                }}
            >
                {t('pages.fishbone.no_icon')}
            </div>
        ) : (
            <div className="text-left">
                {allIcons.map((i, index) => (
                    <Tag.CheckableTag
                        key={'i' + index}
                        checked={iconFilter == i}
                        onClick={() => {
                            iconFilter == i
                                ? setIconFilter(null)
                                : setIconFilter(i);
                        }}
                        className={[
                            'tag'
                        ].join(' ')}
                        style={{
                            verticalAlign: 'middle',
                            paddingBottom: '0.34rem',
                            paddingTop: '0.3rem'

                        }}
                    >
                        <FontAwesomeIcon
                            style={{ fontSize: '0.9rem' }}
                            icon={fal[i]}
                        ></FontAwesomeIcon>
                    </Tag.CheckableTag>
                ))}
            </div>
        )}

        <strong
            className="text-left mt-2"
            style={{ marginBottom: '0.5rem' }}
        >
            {t('pages.fishbone.filters.responsible.title')}
        </strong>

        <div className="text-left mb-1">
            <AutoComplete
                value={responsibleFilter}
                options={responsibleOptions}
                onChange={(value: string) => setResponsibleFilter(value || "")}
                onClear={() => setResponsibleFilter("")}
                style={{ width: '100%', marginLeft: 'auto', marginRight: '1em' }}
                filterOption={(input, option) =>
                    String(option?.value || '').toLowerCase().includes(String(input || '').toLowerCase())
                }
            >
                <Input
                    placeholder={t('pages.fishbone.filters.responsible.placeholder')}
                    allowClear
                    className="SearchInput"
                />
            </AutoComplete>
        </div>

        <strong
            className="text-left mt-2"
            style={{ marginBottom: '0.5rem' }}
        >
            {t('pages.fishbone.filters.completion.title')}
        </strong>

        <div className="text-left mb-1">
            {completions.map((t, index) => (
                <Tag.CheckableTag
                    key={'t' + index}
                    checked={completionFilter == t.value}
                    onClick={() => {
                        if (t.value == "not_started") {

                            if (completionFilter == "not_started") {
                                setCompletionFilter(null)
                            } else {
                                setCompletionFilter("not_started")
                            }
                            return
                        }

                        if (t.value == "in_progress") {
                            if (completionFilter == "in_progress") {
                                setCompletionFilter(null)
                            } else {
                                setCompletionFilter("in_progress")
                            }
                            return
                        }

                        if (t.value == "completed") {
                            if (completionFilter == "completed") {
                                setCompletionFilter(null)
                            } else {
                                setCompletionFilter("completed")
                            }
                            return
                        }


                    }}
                    className={[
                        'tag'
                    ].join(' ')}
                >
                    {t.name || t.value}
                </Tag.CheckableTag>
            ))}
        </div>

        <strong
            className="text-left mt-2"
            style={{ marginBottom: '0.5rem' }}
        >
            {t('pages.fishbone.filters.dates.title')}
        </strong>

        <div className="text-left mb-1">
            {commonTimes.map((t, index) => (
                <Tag.CheckableTag
                    key={'t' + index}
                    checked={timeStartFilter == t.value || timeEndFilter == t.value}
                    onClick={() => {
                        if (t.value == "undefined") {

                            if (timeStartFilter == "undefined") {
                                setTimeStartFilter(null)
                                setTimeEndFilter(null)
                            } else {
                                setTimeStartFilter("undefined")
                                setTimeEndFilter(null)
                            }
                            return
                        }

                        if (t.value == "past") {
                            if (timeStartFilter == "past") {
                                setTimeStartFilter(null)
                                setTimeEndFilter(null)
                            } else {
                                setTimeStartFilter("past")
                                setTimeEndFilter(null)
                            }
                            return
                        }

                        if (t.value == "overdue") {
                            if (timeEndFilter == "overdue") {
                                setTimeStartFilter(null)
                                setTimeEndFilter(null)
                            } else {
                                setTimeStartFilter(null)
                                setTimeEndFilter("overdue")
                            }
                            return
                        }
                    }}
                    className={[
                        'tag'
                    ].join(' ')}
                >
                    {t.name || t.value}
                </Tag.CheckableTag>
            ))}
        </div>

        <div className="text-left mb-1">
            {startOnTimes.map((t, index) => (
                <Tag.CheckableTag
                    key={'t' + index}
                    checked={timeStartFilter == t.value}
                    onClick={() => {
                        // Add filter if not present, remove it if already present
                        timeStartFilter == t.value
                            ? setTimeStartFilter(null)
                            : setTimeStartFilter(t.value);
                        //tagFilter == t ? setTagFilter(null) : setTagFilter(t)
                    }}
                    className={[
                        'tag'
                    ].join(' ')}
                >
                    {t.name || t.value}
                </Tag.CheckableTag>
            ))}
        </div>




        <div className="text-left">
            {endOnTimes.map((t, index) => (
                <Tag.CheckableTag
                    key={'t' + index}
                    checked={timeEndFilter == t.value}
                    onClick={() => {
                        // Add filter if not present, remove it if already present
                        timeEndFilter == t.value
                            ? setTimeEndFilter(null)
                            : setTimeEndFilter(t.value);
                        //tagFilter == t ? setTagFilter(null) : setTagFilter(t)
                    }}
                    className={[
                        'tag'
                    ].join(' ')}
                >
                    {t.name || t.value}
                </Tag.CheckableTag>
            ))}
        </div>
    </>
}